<template>
  <v-card>
    <v-card-title class="justify-center">
      <h2>DETALHES DO LEILÃO</h2>
    </v-card-title>
    <v-alert :value="true" v-if="alerta" :type="tipo">
      <h3>{{ alerta }}</h3>
    </v-alert>
    <v-divider></v-divider>
    <v-card-text v-if="leilao">
      <v-layout wrap justify-space-around>
        <v-flex xs5 class="mt-4">
          Data de inicío: <b>{{ leilao.data_inicio | formatDate('DD/MM/YYYY') }}</b>
        </v-flex>
        <v-flex xs5 class="mt-4">
          Horário de inicío: <b>{{ leilao.data_inicio | formatDate('HH:mm') }}</b>
        </v-flex>
        <v-flex xs5>
          Data de inicío: <b>{{ leilao.data_fim | formatDate('DD/MM/YYYY') }}</b>
        </v-flex>
        <v-flex xs5>
          Horário de inicío: <b>{{ leilao.data_fim | formatDate('HH:mm') }}</b>
        </v-flex>
        <v-flex xs5>
          Status: <b>{{
            leilao.status === 1 ?
            'em aberto' :
            leilao.status === 2 ? 'encerrado' :
            leilao.status === 3 ? 'cancelado' :
            leilao.status === 4 ? 'em andamento' :
            'concluído'
          }}</b>
        </v-flex>
        <v-flex xs5>
          Valor Inicial: <b>{{ leilao.valor_inicial | currency({ fractionCount: 2 }) }}</b>
        </v-flex>
        <template v-if="ultimo_lance">
          <v-flex xs12 class="mt-4">
            <h4>ÚLTIMO LANCE</h4>
          </v-flex>
          <v-flex xs5>
            Responsavel: <b>{{ ultimo_lance.responsavel.nome_fantasia }}</b>
          </v-flex>
          <v-flex xs5>
            CNPJ: <b>{{ ultimo_lance.responsavel.cnpj }}</b>
          </v-flex>
          <v-flex xs5>
            Data: <b>{{ ultimo_lance.data | formatDate('DD/MM/YYYY') }}</b>
          </v-flex>
          <v-flex xs5>
            Hora: <b>{{ ultimo_lance.data | formatDate('HH:mm') }}</b>
          </v-flex>
          <v-flex xs11>
            Valor: <b>{{ ultimo_lance.valor | currency({ fractionCount: 2 }) }}</b>
          </v-flex>
          <v-flex xs11>
            Telefones: <b>{{ ultimo_lance.responsavel.contato1 ? `${formatarTelefone(ultimo_lance.responsavel.contato1)}` : '' }}{{ ultimo_lance.responsavel.contato2 ? `, ${formatarTelefone(ultimo_lance.responsavel.contato2)}` : '' }}{{ ultimo_lance.responsavel.contato3 ? `, ${formatarTelefone(ultimo_lance.responsavel.contato3)}` : '' }}
            </b>
          </v-flex>
          <v-flex xs11>
            E-mail: {{ ultimo_lance.responsavel.email }}
          </v-flex>
        </template>
        <v-flex xs12 class="mt-4">
          <h4>VEÍCULO LEILOADO</h4>
        </v-flex>
        <v-flex xs5>
          Placa: {{ leilao.veiculo_leiloado.identificacao }}
        </v-flex>
        <v-flex xs5>
          Novo: {{ leilao.veiculo_leiloado.usado ? 'NÃO' : 'SIM' }}
        </v-flex>
        <v-flex xs5>
          Código: {{ leilao.veiculo_leiloado.id_veiculo }}
        </v-flex>
        <v-flex xs5>
          Cor: {{ leilao.veiculo_leiloado.cor_texto }}
        </v-flex>
        <v-flex xs5>
          Modolo: {{ leilao.veiculo_leiloado.modelo }}
        </v-flex>
        <v-flex xs5>
          Marca: {{ leilao.veiculo_leiloado.marca }}
        </v-flex>
        <v-flex xs12 class="ma-4">
          <v-btn
            flat
            color="info"
            block
            @click="visualizarVeiculo = true"
        >
          Mostrar mais informações do veículo
        </v-btn>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <h4>HISTORÍCO DE LANCES</h4>
        </v-flex>
        <v-flex
          xs12
          class="mt-4"
          style="
            height: 9.5em;
            overflow-y: auto;
            overflow-x: hidden;
          "
        >
          <v-list>
            <template v-for="(item, index) in lances">
              <v-list-tile :key="`${index}item`">
                <v-list-tile-avatar>
                  <v-icon :color="item.id === ultimo_lance.id ? 'info' : ''">{{ item.id === ultimo_lance.id ? 'emoji_events' : 'pan_tool' }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.responsavel.nome_fantasia }} - {{ item.responsavel.cnpj }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    As {{ item.data | formatDate('HH:mm') }} de {{ item.data | formatDate('DD/MM/YYYY') }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ item.valor | currency({ fractionCount: 2 }) }}
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-menu
                    left
                    offset-y
                    :nudge-width="200"
                    transition="scale-transition"
                    ref="menu"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        flat
                        v-on="on"
                        color="error"
                        :disabled="disabledCancelamento(item)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text class="error--text text-h6 text-center">
                        Tem certeza que deseja cancelar esse lance?
                      </v-card-text>
                      <v-card-actions class="justify-space-around">
                        <v-flex xs6>
                          <v-btn flat block>
                            Não
                          </v-btn>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs6 @click="cancelarLances(item)">
                          <v-btn color="error" flat block>
                            SIM
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index < lances.length - 1" :key="`${index}divider`"></v-divider>
            </template>
            <v-list-tile v-if="lances.length === 0">
              <v-list-tile-content>
                  <v-list-tile-title>
                    Ainda nenhum lance foi dado
                  </v-list-tile-title>
              </v-list-tile-content>
              </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="justify-space-around">
      <v-btn
        @click="$emit('fechar')"
        flat
        block
      >
        Fechar
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="visualizarVeiculo" v-if="visualizarVeiculo" scrollable width="55em">
      <dialog-visualizar-veiculo
        :veiculo="leilao.veiculo_leiloado"
        @fechar="visualizarVeiculo = false"
        :mostrarBotao="false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import DialogVisualizarVeiculo from '@/components/dialogs/VisualizarVeiculo'
export default {
  components: { DialogVisualizarVeiculo },
  props: ['leilaoSelecionado'],
  data: () => ({
    alerta: '',
    tipo: 'error',
    lances: [],
    leilao: {
      empresa: undefined,
      cliente: undefined
    },
    ultimo_lance: undefined,
    visualizarVeiculo: false
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  beforeMount () {
    this.leilao = { ...this.leilaoSelecionado }
    if (this.leilaoSelecionado) {
      this.ultimo_lance = this.leilaoSelecionado.ultimo_lance
      this.pegarLances()
    }
  },
  methods: {
    ativarAlerta (texto, tipo, permanente) {
      this.alerta = texto
      this.tipo = tipo
      if (!permanente) {
        const interval = setInterval(() => {
          this.alerta = undefined
          clearInterval(interval)
        }, 5000)
      }
    },
    pegarLances () {
      this.$store.dispatch('lancesLeilao', {
        method: 'GET',
        parametros: {
          leilao: this.leilao.id,
          cancelado: false
        }
      }).then(json => {
        this.lances = json
      })
    },
    pegarLeilao () {
      this.$store.dispatch('leilaoVeiculos', {
        id: this.leilaoSelecionado.id
      }).then(json => {
        this.leilao = { ...json }
      })
    },
    cancelarLances (lance) {
      this.$store.dispatch('lancesLeilao', {
        method: 'DELETE',
        id: lance.id,
        parametros: {
          admin: true
        }
      }).then(() => {
        this.pegarLeilao()
        this.pegarLances()
        this.ativarAlerta('Lance cancelado com sucesso', 'info', false)
      })
    },
    disabledCancelamento (item) {
      if (this.lances.length === 1 || item.aceito || (item.id !== this.ultimo_lance.id)) return true
      return false
    },
    formatarTelefone (numero) {
      const numeroLimpo = numero.replace(/\D/g, '')
      if (numeroLimpo.length === 10) {
        return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 6)}-${numeroLimpo.substring(6)}`
      } else if (numeroLimpo.length === 11) {
        return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 3)} ${numeroLimpo.substring(3, 7)}-${numeroLimpo.substring(7)}`
      } else if (numeroLimpo.length === 9) {
        return `(${numeroLimpo.substring(0, 1)}) ${numeroLimpo.substring(1, 5)}-${numeroLimpo.substring(5)}`
      } else if (numeroLimpo.length === 8) {
        return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 6)}-${numeroLimpo.substring(6)}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style>

</style>
